import React, { useEffect, useState } from "react";
import Style from "../Style/Gallery.module.scss";
import axios from "axios";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { motion } from "framer-motion";

const GalleryPage = ({ darkMode }) => {
  const [images, setImages] = useState([]);
  const baseURL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    fetchGalleryImages();
  }, []);

  const fetchGalleryImages = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/images`);
      setImages(res.data);
    } catch (err) {
      console.error("Error fetching images:", err);
    }
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -50 }}
        transition={{
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1],
        }}
      >
        <HelmetProvider>
          <Helmet>
           
            <link rel="canonical" href="gallery" />
          </Helmet>
        </HelmetProvider>

        <div className={`${Style.Gallery} ${darkMode ? Style.dark : ""}`}>
          <div className={Style.wrapper}>
            <div className={Style.GalleryDisk}>
              <h4>Our Gallery</h4>
              <p>Explore some moments from our educational activities.</p>
            </div>

            <div className={Style.GalleryFlex}>
              {images.length > 0 ? (
                images.map((img, i) => (
                  <div className={Style.GalleryWrap} key={i}>
                    <img src={img.image_url} alt={`Gallery ${i + 1}`} />
                  </div>
                ))
              ) : (
                <p style={{ textAlign: "center", width: "100%" }}>
                  No images available.
                </p>
              )}
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default GalleryPage;
